import NoRole from "./NoRole";

export default NoRole;
